/* import __COLOCATED_TEMPLATE__ from './semifinal50-startlist-interface.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { TrackedArray } from 'tracked-built-ins';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

export default class Semifinal50StartlistComponent extends Component
{
	@service store;
	@service csv;
	@service sprintTools;

	@tracked quarterfinalsEvent;

	@tracked startTimeS1;
	@tracked startTimeS2;

	@tracked Q1ClassGroup;
	@tracked Q2ClassGroup;
	@tracked Q3ClassGroup;
	@tracked Q4ClassGroup;
	@tracked Q5ClassGroup;

	@tracked S1ClassGroup;
	@tracked S2ClassGroup;

	@tracked S1Assignments;
	@tracked S2Assignments;

	// 5 lucky losers for 50 format
	@tracked LL1;
	@tracked LL2;
	@tracked LL3;
	@tracked LL4;
	@tracked LL5;
	@tracked LLOthers;

	@action
	async quarterfinalsEventChanged(browserEvent)
	{
		if(browserEvent.target.value == '-')
		{
			this.quarterfinalsEvent = null;
		}
		else
		{
			var event = await this.store.findRecord('Event', browserEvent.target.value);
			this.quarterfinalsEvent = event;
		}

		if(this.quarterfinalsEvent?.id)
		{
			await this.sprintTools.fetchResultsForEvent(this.quarterfinalsEvent.id);
		}
		this.Q1ClassGroup = null;
		this.Q2ClassGroup = null;
		this.Q3ClassGroup = null;
		this.Q4ClassGroup = null;
		this.Q5ClassGroup = null;
	}

	@action
	async Q1ClassGroupChanged(browserEvent)
	{
		if(browserEvent.target.value == '-')
		{
			this.Q1ClassGroup = null;
		}
		else
		{
			var classGroup = await this.store.findRecord('ClassGroup', browserEvent.target.value);
			this.Q1ClassGroup = classGroup;
		}
		this.calculateHeatAssignments();
	}

	@action
	async Q2ClassGroupChanged(browserEvent)
	{
		if(browserEvent.target.value == '-')
		{
			this.Q2ClassGroup = null;
		}
		else
		{
			var classGroup = await this.store.findRecord('ClassGroup', browserEvent.target.value);
			this.Q2ClassGroup = classGroup;
		}
		this.calculateHeatAssignments();
	}

	@action
	async Q3ClassGroupChanged(browserEvent)
	{
		if(browserEvent.target.value == '-')
		{
			this.Q3ClassGroup = null;
		}
		else
		{
			var classGroup = await this.store.findRecord('ClassGroup', browserEvent.target.value);
			this.Q3ClassGroup = classGroup;
		}
		this.calculateHeatAssignments();
	}

	@action
	async Q4ClassGroupChanged(browserEvent)
	{
		if(browserEvent.target.value == '-')
		{
			this.Q4ClassGroup = null;
		}
		else
		{
			var classGroup = await this.store.findRecord('ClassGroup', browserEvent.target.value);
			this.Q4ClassGroup = classGroup;
		}
		this.calculateHeatAssignments();
	}

	@action
	async Q5ClassGroupChanged(browserEvent)
	{
		if(browserEvent.target.value == '-')
		{
			this.Q5ClassGroup = null;
		}
		else
		{
			var classGroup = await this.store.findRecord('ClassGroup', browserEvent.target.value);
			this.Q5ClassGroup = classGroup;
		}
		this.calculateHeatAssignments();
	}

	@action
	async S1ClassGroupChanged(browserEvent)
	{
		if(browserEvent.target.value == '-')
		{
			this.S1ClassGroup = null;
		}
		else
		{
			var classGroup = await this.store.findRecord('ClassGroup', browserEvent.target.value);
			this.S1ClassGroup = classGroup;
			this.startTimeS1 = dayjs(classGroup.startTime).format("HH:mm:ss");
		}
	}

	@action
	async S2ClassGroupChanged(browserEvent)
	{
		if(browserEvent.target.value == '-')
		{
			this.S2ClassGroup = null;
		}
		else
		{
			var classGroup = await this.store.findRecord('ClassGroup', browserEvent.target.value);
			this.S2ClassGroup = classGroup;
			this.startTimeS2 = dayjs(classGroup.startTime).format("HH:mm:ss");
		}
	}

	@action
	exportHeatStartListCSV()
	{
		if (!this.S1Assignments || !this.S2Assignments) {
			return;
		}

		var buildData = (assignments, classGroup, startTime) => {
			var data = [...this.sprintTools.getCSVHeaders()];
			for (const result of assignments) {
				data.push(this.sprintTools.buildCSVRow(result, classGroup, startTime, result.bib));
			}
			return data;
		};

		this.csv.export(buildData(this.S1Assignments, this.S1ClassGroup, this.startTimeS1), {fileName:'S1-50-semifinalsStartlist.csv',withSeparator:false});
		this.csv.export(buildData(this.S2Assignments, this.S2ClassGroup, this.startTimeS2), {fileName:'S2-50-semifinalsStartlist.csv',withSeparator:false});
	}

	@action
	async createClasses()
	{
		var destinationEvent = this.args.destinationEvent;
		var destinationClasses = await destinationEvent.get('classes');

		await this.sprintTools.createClassesForHeat(destinationEvent, destinationClasses, this.S1ClassGroup, this.S1Assignments);
		await this.sprintTools.createClassesForHeat(destinationEvent, destinationClasses, this.S2ClassGroup, this.S2Assignments);
	}

	@action
	async createEntries()
	{
		var destinationEvent = this.args.destinationEvent;
		var destinationEntries = await destinationEvent.get('entries');
		var destinationClasses = await destinationEvent.get('classes');

		await this.sprintTools.createEntriesForHeat(destinationEvent, destinationEntries, destinationClasses, this.S1ClassGroup, this.S1Assignments, this.startTimeS1, false);
		await this.sprintTools.createEntriesForHeat(destinationEvent, destinationEntries, destinationClasses, this.S2ClassGroup, this.S2Assignments, this.startTimeS2, false);
	}

	async calculateLuckyLosers()
	{
		var Q1Results = [...(await this.Q1ClassGroup.resultsSorted)];
		var Q2Results = [...(await this.Q2ClassGroup.resultsSorted)];
		var Q3Results = [...(await this.Q3ClassGroup.resultsSorted)];
		var Q4Results = [...(await this.Q4ClassGroup.resultsSorted)];
		var Q5Results = [...(await this.Q5ClassGroup.resultsSorted)];

		// Collect all finishers from 4th place onwards (after top 3 who advance directly)
		// Lucky losers are the next fastest 5 from any position
		var luckyLoserCandidates = [];

		var addCandidatesFromHeat = function(results) {
			// Skip top 3 (indices 0,1,2), collect everyone else
			for(var i = 3; i < results.length; i++) {
				if(results[i] && results[i].status == 'OK' && results[i].totalTimeInMilliseconds != null) {
					luckyLoserCandidates.push(results[i]);
				}
			}
		};

		addCandidatesFromHeat(Q1Results);
		addCandidatesFromHeat(Q2Results);
		addCandidatesFromHeat(Q3Results);
		addCandidatesFromHeat(Q4Results);
		addCandidatesFromHeat(Q5Results);

		// Sort by time (fastest first)
		luckyLoserCandidates.sort((a, b) => a.totalTimeInMilliseconds - b.totalTimeInMilliseconds);

		// Select top 5 as lucky losers
		this.LL1 = luckyLoserCandidates[0] || null;
		this.LL2 = luckyLoserCandidates[1] || null;
		this.LL3 = luckyLoserCandidates[2] || null;
		this.LL4 = luckyLoserCandidates[3] || null;
		this.LL5 = luckyLoserCandidates[4] || null;

		// Rest go to unlucky losers
		var LLOthers = new TrackedArray();
		for(var i = 5; i < luckyLoserCandidates.length; i++) {
			LLOthers.push(luckyLoserCandidates[i]);
		}
		this.LLOthers = LLOthers;
	}

	async calculateHeatAssignments()
	{
		var S1Assignments = [];
		var S2Assignments = [];

		var Q1ClassGroup = this.Q1ClassGroup;
		var Q2ClassGroup = this.Q2ClassGroup;
		var Q3ClassGroup = this.Q3ClassGroup;
		var Q4ClassGroup = this.Q4ClassGroup;
		var Q5ClassGroup = this.Q5ClassGroup;

		if(	Q1ClassGroup == null ||
			Q2ClassGroup == null ||
			Q3ClassGroup == null ||
			Q4ClassGroup == null ||
			Q5ClassGroup == null)
		{
			return false;
		}

		await this.calculateLuckyLosers();

		var Q1Results = [...(await this.Q1ClassGroup.resultsSorted)];
		var Q2Results = [...(await this.Q2ClassGroup.resultsSorted)];
		var Q3Results = [...(await this.Q3ClassGroup.resultsSorted)];
		var Q4Results = [...(await this.Q4ClassGroup.resultsSorted)];
		var Q5Results = [...(await this.Q5ClassGroup.resultsSorted)];

		// S1: Q1.1, Q2.1, Q1.2, Q2.2, Q3.2, Q1.3, Q2.3, LL3, LL4, LL5
		// S2: Q3.1, Q4.1, Q5.1, Q4.2, Q5.2, Q3.3, Q4.3, Q5.3, LL1, LL2

		// Build S1 assignments in exact table order
		var assignToHeat = (assignments, result, startOrder) => {
			if(result) {
				result.set('heatStartOrder', startOrder);
				assignments.push(result);
			}
		};

		// S1: Q1.1, Q2.1, Q1.2, Q2.2, Q3.2, Q1.3, Q2.3, LL3, LL4, LL5
		assignToHeat(S1Assignments, Q1Results[0], 1);   // Q1.1
		assignToHeat(S1Assignments, Q2Results[0], 2);   // Q2.1
		assignToHeat(S1Assignments, Q1Results[1], 3);   // Q1.2
		assignToHeat(S1Assignments, Q2Results[1], 4);   // Q2.2
		assignToHeat(S1Assignments, Q3Results[1], 5);   // Q3.2
		assignToHeat(S1Assignments, Q1Results[2], 6);   // Q1.3
		assignToHeat(S1Assignments, Q2Results[2], 7);   // Q2.3
		assignToHeat(S1Assignments, this.LL3, 8);       // LL3
		assignToHeat(S1Assignments, this.LL4, 9);       // LL4
		assignToHeat(S1Assignments, this.LL5, 10);      // LL5

		// S2: Q3.1, Q4.1, Q5.1, Q4.2, Q5.2, Q3.3, Q4.3, Q5.3, LL1, LL2
		assignToHeat(S2Assignments, Q3Results[0], 1);   // Q3.1
		assignToHeat(S2Assignments, Q4Results[0], 2);   // Q4.1
		assignToHeat(S2Assignments, Q5Results[0], 3);   // Q5.1
		assignToHeat(S2Assignments, Q4Results[1], 4);   // Q4.2
		assignToHeat(S2Assignments, Q5Results[1], 5);   // Q5.2
		assignToHeat(S2Assignments, Q3Results[2], 6);   // Q3.3
		assignToHeat(S2Assignments, Q4Results[2], 7);   // Q4.3
		assignToHeat(S2Assignments, Q5Results[2], 8);   // Q5.3
		assignToHeat(S2Assignments, this.LL1, 9);       // LL1
		assignToHeat(S2Assignments, this.LL2, 10);      // LL2

		this.S1Assignments = S1Assignments;
		this.S2Assignments = S2Assignments;
	}
}
